import React from 'react';
import Routes from './routes.js'
import './App.css'

export default function App() {
  return <Routes />
}